import { ForwardedRef, forwardRef, useMemo } from 'react';
import { Input } from '@components/input/src';
import { getCurrencySymbol } from '@utils/get-currency-symbol/get-currency-symbol';

import { Props } from './input-price.type';

export const InputPrice = forwardRef(
  ({ hasError, currency, readOnly, disabled, ...props }: Props, ref: ForwardedRef<HTMLInputElement>) => {
    const currencySymbol = useMemo(() => getCurrencySymbol(currency), [currency]);

    return (
      <Input
        {...props}
        readOnly={readOnly}
        disabled={disabled}
        ref={ref}
        suffix={currencySymbol}
        className='w-full'
        type='number'
        hasError={hasError}
      />
    );
  }
);
